import React from 'react';
import PropTypes from 'prop-types';
import FontAwesome from 'react-fontawesome';
import s from './LoadingProgress.module.css';

const LoadingProgressInline = ({ show }) =>
  show ? (
    <div>
      <FontAwesome pulse size="2x" name={'spinner'} />
    </div>
  ) : (
    <div />
  );

const LoadingProgressPure = ({ show, coffee }) => {
  const icon = coffee ? 'coffee' : 'spinner';
  return show ? (
    <div className={`loading-overlay ${s.loadingOverlay}`}>
      <div className={`loading-spinner ${s.loadingSpinner}`}>
        <FontAwesome pulse size="5x" name={icon} />
      </div>
    </div>
  ) : (
    <div />
  );
};

LoadingProgressPure.propTypes = {
  show: PropTypes.bool,
  coffee: PropTypes.bool,
};

const LoadingProgress = LoadingProgressPure;
export { LoadingProgress as default, LoadingProgressInline };
